import { render, staticRenderFns } from "./serviceselecter.vue?vue&type=template&id=0c49e04e&scoped=true&"
import script from "./serviceselecter.vue?vue&type=script&lang=js&"
export * from "./serviceselecter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c49e04e",
  null
  
)

export default component.exports